import { render, staticRenderFns } from "./stepItem.vue?vue&type=template&id=392e4b45&scoped=true"
import script from "./stepItem.vue?vue&type=script&lang=js"
export * from "./stepItem.vue?vue&type=script&lang=js"
import style0 from "./stepItem.vue?vue&type=style&index=0&id=392e4b45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392e4b45",
  null
  
)

export default component.exports